import FirebaseHandlerBase from "../firebase_handler_base";
import {IFreePlayVoucher} from "../../../free_play/Free_play_voucher";
import {SYSTEM_EVENTS} from "../../../../events/events";
import Event from '../../../../utils/event';
import _ from "../../../../utils/underscore";
import {FP_VOUCHER_TYPES} from "../../../free_play/free_play_consts";
import {IExpirationDate, ISubscriptionParams} from "../firebase_const";


enum TYPES{
  ADDED = "added",
  REMOVED = "removed",
  MODIFIED = "modified"
}

interface FPVoucherData{
  CurrentBalance: number;
  ExpirationDate: IExpirationDate;
  FreePlayId: number;
  FreePlayTypeId: number;
  GameTypeIdList: number[];
  MaxBetAmount: number;
  OriginAmount: number;
  UpdateCounter: number;
  Winnings: number;
  PendingDeletion?: boolean;
}

interface IFPReceivedVoucher{
  data: FPVoucherData;
  type: TYPES;
  id: string;
}

export default class FreeplayHandler extends FirebaseHandlerBase{
  static class: string = "FreeplayHandler";

  protected getSubscriptionParams(): ISubscriptionParams {
    return {
      eventName: 'freePlay',
      successCallback: this._updateFreePlay,
    };
  }

  protected getFeatureName(): string {
    return "FP";
  }

  protected getFeatureLabel(): string {
    return "FreePlay";
  }

  protected getFallbackServiceName(): string{
    return "Wallet";
  }

  private _updateFreePlay = (data: IFPReceivedVoucher[]) => {
    this.logger.debug('Firebase got FP message. Raw data: ' + JSON.stringify(data));

    if(data.length !== 0){
      const updatedVouchers = this._parseVouchers(data);
      Event.fire(SYSTEM_EVENTS.SESSION_EVENT_FREE_PLAY_RECEIVED, updatedVouchers);
      this.logger.debug('Firebase got FP message. Parsed data: ' + JSON.stringify(updatedVouchers));
    }
    this.serviceFactory.firebaseElasticService().sendMessageUpdate(this.getFeatureLabel(), JSON.stringify(data));
  }

  private _parseVouchers(freeplayData: IFPReceivedVoucher[]): IFreePlayVoucher[]{
    const updatedVouchers = [] as IFreePlayVoucher[];
    freeplayData.forEach((voucher: IFPReceivedVoucher) => {
      const receivedData: FPVoucherData = voucher.data;
      const FPvoucher: IFreePlayVoucher = {
        ID: receivedData.FreePlayId.toString(),
        CurrentBalance: receivedData.CurrentBalance,
        Winnings: receivedData.Winnings,
        FreePlayTypeId: (receivedData.FreePlayTypeId ? receivedData.FreePlayTypeId.toString() : '1') as FP_VOUCHER_TYPES,
        OriginAmount: receivedData.OriginAmount,
        ExpirationDate: receivedData.ExpirationDate ? new Date(1000*receivedData.ExpirationDate.seconds) : undefined,
        SpinBetAmount: receivedData.MaxBetAmount,
        GameTypeIDList: receivedData.GameTypeIdList,
        PendingDeletion: _.isNullOrUndefined(receivedData.PendingDeletion) ? false : _.toBoolean(receivedData.PendingDeletion)
      };
      switch(voucher.type) {
        case TYPES.ADDED:
        case TYPES.MODIFIED:
          updatedVouchers.push(FPvoucher);
          break;
        case TYPES.REMOVED:
          this.logger.debug(`Firebase got FP message. Remove voucher id: ${FPvoucher.ID}`);
          Event.fire(SYSTEM_EVENTS.SESSION_EVENT_FREE_PLAY_REMOVED, FPvoucher.ID);
          break;
      }
    });

    return updatedVouchers;
  }
}